import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { Container, Box, CircularProgress, Typography } from '@mui/material'
import { handleOAuthCallback } from '../services/salesforce'

interface CallbackPageProps {
  onAuthenticated: () => void
}

export default function CallbackPage({ onAuthenticated }: CallbackPageProps) {
  const navigate = useNavigate()

  useEffect(() => {
    async function processCallback() {
      // ハッシュがない場合はスキップ（既に処理済み）
      if (!window.location.hash) {
        console.log('No hash found, skipping callback processing')
        return
      }

      try {
        await handleOAuthCallback()
        onAuthenticated()

        // localStorageからCareerIdを取得
        const careerId = localStorage.getItem('sf_career_id')

        if (careerId) {
          navigate(`/editor/${careerId}`, { replace: true })
        } else {
          navigate('/editor', { replace: true })
        }
      } catch (error) {
        console.error('認証エラー:', error)
        navigate('/login', { replace: true })
      }
    }

    processCallback()
  }, [navigate, onAuthenticated])

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
        }}
      >
        <CircularProgress size={60} />
        <Typography variant="h6">認証処理中...</Typography>
      </Box>
    </Container>
  )
}
